/**=====================================================================================*/
/**========================= Start Price Details Popup Script ===========================*/
/**======================================================================================*/

// Create a popup functionality
(function() {
    let dynamicContent = '<h3>Price Details</h3><p>We strive to bring you the lowest prices. The strike-through or reference price indicates the Product’s suggested retail price (SRP) and may or may not have been offered by us or other retailers at or above that price in the past and may not be offered for sale at that price on any future date. Thus, the strike-through price may not necessarily be the prevailing market price, regular retail price, or former price of a Product. In addition, Products may be offered by us or other retailers at the same or lower prices during future promotional events beginning on or after the last day of any advertised promotion.</p><p>The price for Products available for purchase through the Websites will be displayed in U.S. Dollars unless otherwise noted as Canadian Dollars. The prices displayed exclude applicable taxes and any shipping fees, which are displayed at checkout. We reserve the right to change any of the Product prices or fees that we charge, or to institute new or additional fees, at any time upon notice to you.</p><p><a href="https://checkout.nolahmattress.com/pages/terms-and-conditions" target="_blank" title="https://checkout.nolahmattress.com/pages/terms-and-conditions">Learn More</a></p>'; // Variable to hold dynamic content

    const createPopup = () => {
        // Create overlay
        const overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        overlay.style.zIndex = '999';
        overlay.classList.add('popup-overlay');

        // Create popup container
        const popup = document.createElement('div');
        popup.style.position = 'fixed';
        // popup.style.width = '680px';
        // popup.style.height = '468px';
        // popup.style.backgroundColor = '#fff';
        // popup.style.top = '50%';
        // popup.style.left = '50%';
        // popup.style.transform = 'translate(-50%, -50%)';
        popup.style.zIndex = '1000';
        popup.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        popup.style.borderRadius = '0px';
        popup.classList.add('popup-container');

        const popupWrapper = document.createElement('div');
        popupWrapper.classList.add('popup-wrapper');
      
      
        // Create content container
        const contentContainer = document.createElement('div');
        contentContainer.style.padding = '2.4rem';
        contentContainer.style.overflowY = 'auto';
        //contentContainer.style.height = 'calc(100% - 40px)'; // Adjust for close button
        contentContainer.style.height = 'calc(100%)'; // Adjust for close button
        contentContainer.innerHTML = dynamicContent; // Inject dynamic content
        contentContainer.classList.add('popup-content');

        // Create close button
        const closeButton = document.createElement('button');
        closeButton.style.position = 'absolute';
        closeButton.style.top = '20px';
        closeButton.style.right = '20px';
        closeButton.style.background = 'none';
        closeButton.style.border = 'none';
        closeButton.style.cursor = 'pointer';
        closeButton.innerHTML = `<svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 96 960 960' width='24'><path d='M256 856 200 800l224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z'/></svg>`;
        closeButton.classList.add('popup-close');

        // Append elements
        popup.appendChild(popupWrapper);
        popupWrapper.appendChild(closeButton);
        popupWrapper.appendChild(contentContainer);
        overlay.appendChild(popup);
        document.body.appendChild(overlay);

        // Close popup on click outside or on close button
        const closePopup = () => {
            document.body.removeChild(overlay);
        };

        overlay.addEventListener('click', (event) => {
            if (event.target === overlay) closePopup();
        });

        closeButton.addEventListener('click', closePopup);
    };

    // Add event listener to open popup
    document.querySelectorAll('.MPFTitleDetails_popup').forEach(button => {
        button.addEventListener('click', createPopup);
    });

    // Expose method to set dynamic content
    window.setPopupContent = (content) => {
        dynamicContent = content;
    };
})();
/**=====================================================================================*/
/**========================== End Price Details Popup Script ===========================*/
/**======================================================================================*/

/**=====================================================================================*/
/**======================== Start WGD Mattress Product Popup Script =======================*/
/**======================================================================================*/
let eligibleAmount = parseFloat(document.querySelector('.wgd-eligible-amount')?.textContent.trim());
(function() {
let wgdSetupContent = `
  <h3>In-Home Setup &amp; Removal</h3>
  <p> 
    In-Home Setup &amp; Removal is scheduled and conducted by Ryder, our service provider, and is available for new Nolah mattresses.
    Please note that Ryder offers In-Home Setup service only for new Nolah bases; removal service for old bases and bed frames is not currently available.
  </p>
  <br>
  <h3>How It Works:</h3>
  <ol>
    <li>When your items are ready, we’ll ship them to a Ryder facility near you. FedEx will send you email updates tracking the shipment from our facility to Ryder’s.</li>
    <li>Once Ryder receives your items, they’ll contact you to schedule your In-Home Setup &amp; Removal service</li>
    <li>On the scheduled delivery day, you’ll be notified when the Ryder team is about 30 minutes away.</li>
    <li>Ryder will set up your purchase in the room of your choice and remove the old items being replaced.</li>
  </ol>
`;


    const createShippingPopup = () => {
        const overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        overlay.style.zIndex = '999';
        overlay.classList.add('popup-overlay');

        const popup = document.createElement('div');
        popup.style.position = 'fixed';
        popup.style.zIndex = '1000';
        popup.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        popup.style.borderRadius = '0px';
        popup.classList.add('popup-container');

        const popupWrapper = document.createElement('div');
        popupWrapper.classList.add('popup-wrapper');
      
        const contentContainer = document.createElement('div');
        contentContainer.style.padding = '2.4rem';
        contentContainer.style.overflowY = 'auto';
        contentContainer.style.height = 'calc(100%)';
        contentContainer.innerHTML = wgdSetupContent;
        contentContainer.classList.add('popup-content');
        const closeButton = document.createElement('button');
        closeButton.style.position = 'absolute';
        closeButton.style.top = '20px';
        closeButton.style.right = '20px';
        closeButton.style.background = 'none';
        closeButton.style.border = 'none';
        closeButton.style.cursor = 'pointer';
        closeButton.innerHTML = `<svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 96 960 960' width='24'><path d='M256 856 200 800l224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z'/></svg>`;
        closeButton.classList.add('popup-close');
        popup.appendChild(popupWrapper);
        popupWrapper.appendChild(closeButton);
        popupWrapper.appendChild(contentContainer);
        overlay.appendChild(popup);
        document.body.appendChild(overlay);
        const closePopup = () => {
            document.body.removeChild(overlay);
        };

        overlay.addEventListener('click', (event) => {
            if (event.target === overlay) closePopup();
        });

        closeButton.addEventListener('click', closePopup);
    };
    document.querySelectorAll('.wgd-guideline-popup').forEach(button => {
        button.addEventListener('click', createShippingPopup);
    });
    window.setShippingPopupContent = (content) => {
        wgdSetupContent = content;
    };
})();
/**=====================================================================================*/
/**======================== End WGD Mattress Product Popup Script =========================*/
/**======================================================================================*/


/**=====================================================================================*/
/**======================== Start WGD Base Product Popup Script =======================*/
/**======================================================================================*/

// Create a base popup functionality
(function() {
  let basePopupContent = `
    <h3>In-Home Setup for Nolah Bases</h3>
    <p> 
      Ryder also offers In-Home Setup &amp; Removal service for new Nolah mattresses.
      <b>Please note that Ryder offers In-Home Setup service only for new Nolah bases; removal service for old bases and bed frames is not currently available.</b>
    </p>
    <br>
    <h3>How It Works:</h3>
    <ol>
      <li>When your items are ready, we’ll ship them to a Ryder facility near you. FedEx will send you email updates tracking the shipment from our facility to Ryder’s.</li>
      <li>Once Ryder receives your items, they’ll contact you to schedule your In-Home Setup service.</li>
      <li>On the scheduled delivery day, you’ll be notified when the Ryder team is about 30 minutes away.</li>
      <li>Ryder will set up your purchase in the room of your choice.</li>
    </ol>
  `;
  
  
      const createBasePopup = () => {
          const overlay = document.createElement('div');
          overlay.style.position = 'fixed';
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
          overlay.style.zIndex = '999';
          overlay.classList.add('popup-overlay');
  
          const popup = document.createElement('div');
          popup.style.position = 'fixed';
          popup.style.zIndex = '1000';
          popup.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          popup.style.borderRadius = '0px';
          popup.classList.add('popup-container');
  
          const popupWrapper = document.createElement('div');
          popupWrapper.classList.add('popup-wrapper');
        
          const contentContainer = document.createElement('div');
          contentContainer.style.padding = '2.4rem';
          contentContainer.style.overflowY = 'auto';
          contentContainer.style.height = 'calc(100%)';
          contentContainer.innerHTML = basePopupContent;
          contentContainer.classList.add('popup-content');
          const closeButton = document.createElement('button');
          closeButton.style.position = 'absolute';
          closeButton.style.top = '20px';
          closeButton.style.right = '20px';
          closeButton.style.background = 'none';
          closeButton.style.border = 'none';
          closeButton.style.cursor = 'pointer';
          closeButton.innerHTML = `<svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 96 960 960' width='24'><path d='M256 856 200 800l224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z'/></svg>`;
          closeButton.classList.add('popup-close');
          popup.appendChild(popupWrapper);
          popupWrapper.appendChild(closeButton);
          popupWrapper.appendChild(contentContainer);
          overlay.appendChild(popup);
          document.body.appendChild(overlay);
          const closePopup = () => {
              document.body.removeChild(overlay);
          };
  
          overlay.addEventListener('click', (event) => {
              if (event.target === overlay) closePopup();
          });
  
          closeButton.addEventListener('click', closePopup);
      };
      document.querySelectorAll('.base-popup-trigger').forEach(button => {
          button.addEventListener('click', createBasePopup);
      });
      window.setBasePopupContent = (content) => {
          basePopupContent = content;
      };
  })();
  /**=====================================================================================*/
  /**======================== End WGD Base Product Popup Script =========================*/
  /**======================================================================================*/

/**=====================================================================================*/
/**===================== Start Script Shipping Protection Product =======================*/
/**======================================================================================*/
document.addEventListener("DOMContentLoaded", function () {
  // Function to calculate the ideal price and update the shipping protection price
  function updateShippingProtectionPrice() {
    // Fetch the current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Filter cart items by excluding the specified handles
        const excludedHandles = ["mulberry-protection", "mulberry-protection-1", "mulberry-protection-2", "mulberry-protection-3", "mulberry-protection-4", "mulberry-protection-5", "mulberry-protection-6", "mulberry-protection-7", "mulberry-protection-8", "mulberry-protection-9", "mulberry-protection-10", "mulberry-protection-11", "mulberry-protection-12", "mulberry-protection-13", "mulberry-protection-14", "mulberry-unlimited", "nolah-shipping-protection", "mattress-removal-and-setup", "nolah-shipping-protection"];
        
        // Calculate total cart value excluding excluded products
        const cartTotal = cart.items.reduce((total, item) => {
          if (!excludedHandles.includes(item.handle)) {
            return total + (item.quantity * item.price / 100); // Price is in cents
          }
          return total;
        }, 0);

        // Calculate ideal price (3% of the cart total)
        const idealPrice = cartTotal * 3 / 100;

        // Get the product URL from the shipping protection checkbox (sidecart-addon-toggle)
        const toggleElement = document.querySelector(".sidecart-addon-toggle");
        if (toggleElement) {
          const productUrl = toggleElement.getAttribute("data-product-url");
          
          if (productUrl) {
            // Fetch the product data from Shopify
            fetch(productUrl + ".js")
              .then(response => response.json())
              .then(productData => {
                // Find the closest variant
                const closestVariant = productData.variants.reduce((closest, variant) => {
                  const variantPrice = variant.price / 100; // Convert price from cents to dollars
                  if (!closest || Math.abs(variantPrice - idealPrice) < Math.abs(closest.price / 100 - idealPrice)) {
                    return variant;
                  }
                  return closest;
                }, null);

                if (closestVariant) {
                  // Update the shipping protection price on the page
                  const priceElement = document.querySelector(".shipping_protection_price");
                  if (priceElement) {
                    priceElement.textContent = `$${(closestVariant.price / 100).toFixed(2)}`;
                  }
                }
              })
              .catch(error => console.error("Error fetching product data:", error));
          }
        }
      })
      .catch(error => console.error("Error fetching cart data:", error));
  }

  // Initial update on page load
  updateShippingProtectionPrice();

  // Use setInterval to periodically check for cart updates (e.g., every 2 seconds)
  setInterval(updateShippingProtectionPrice, 2000);

  // Check if the ideal variant is already in the cart and enable the checkout button
  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('toggle');
    const totalPriceElement = document.querySelector('.wrapper .inner-row span');
    const totalPriceDisplayElement = document.querySelector('.total-price');
    const shippingProtectionPriceElement = document.querySelector('.shipping_protection_price');
  
    function getShippingProtectionPrice() {
      const priceText = shippingProtectionPriceElement.textContent.replace('$', '');
      return parseFloat(priceText) || 0;
    }
  
    function formatPrice(price) {
      return Number.isInteger(price) ? `$${price}` : `$${price.toFixed(2)}`;
    }
  
    function updateTotalPrice() {
      let currentTotal = parseFloat(totalPriceElement.textContent.replace(/[^\d.-]/g, ''));
      const shippingProtectionPrice = getShippingProtectionPrice();
      if (toggle.checked) {
        currentTotal += shippingProtectionPrice;
      } else {
        currentTotal -= shippingProtectionPrice;
      }
      const formattedTotal = formatPrice(currentTotal);
      totalPriceElement.textContent = formattedTotal;
      totalPriceDisplayElement.textContent = formattedTotal;
    }
    updateTotalPrice();
    toggle.addEventListener('change', function () {
      updateTotalPrice();
    });
    if (localStorage.getItem('toggleState') === 'checked') {
      toggle.checked = true;
    }
  
    toggle.addEventListener('change', function () {
      localStorage.setItem('toggleState', toggle.checked ? 'checked' : 'unchecked');
      updateTotalPrice();
    });
  });

});
/**=====================================================================================*/
/**===================== End Script Shipping Protection Product =========================*/
/**======================================================================================*/


/**=====================================================================================*/
/**===================== Start Nolan Package Protection Script ==========================*/
/**======================================================================================*/

document.addEventListener('DOMContentLoaded', () => {
    const packageProtectionButton = document.querySelector('.package-protection-button');
    const packageProtectionPopup = document.querySelector('.package-protection-popup');
    const popupContentWrapper = document.querySelector('.popup-content-wrapper');
    const desktopPopupClose = document.querySelector('.desktop-popup-close');

    if (packageProtectionButton && packageProtectionPopup) {
        // Show the popup when button is clicked
        packageProtectionButton.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default anchor behavior
            packageProtectionPopup.style.display = 'flex';
            document.body.classList.add('responsive_popup_styles');
        });

        // Hide the popup when clicking outside of it
        document.addEventListener('click', (event) => {
            if (
                packageProtectionPopup.style.display === 'flex' && 
                !popupContentWrapper.contains(event.target) && 
                !packageProtectionButton.contains(event.target)
            ) {
                packageProtectionPopup.style.display = 'none';
                document.body.classList.remove('responsive_popup_styles');
            }
        });

        // Hide the popup when the close button is clicked
        if (desktopPopupClose) {
            desktopPopupClose.addEventListener('click', () => {
                packageProtectionPopup.style.display = 'none';
                document.body.classList.remove('responsive_popup_styles');
            });
        }
    }
});

/**=====================================================================================*/
/**===================== End Nolan Package Protection Script ==========================*/
/**======================================================================================*/